"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPostLanguage = getPostLanguage;
exports.getLanguageLabel = getLanguageLabel;
exports.getTopicTags = getTopicTags;
const LANGUAGE_TAGS = ['ko', 'en'];
const LANGUAGE_LABELS = {
    ko: '한국어',
    en: 'English',
};
function getPostLanguage(post) {
    const hit = post.tags
        .map((t) => t.toLowerCase())
        .find((t) => LANGUAGE_TAGS.includes(t));
    return hit ?? null;
}
function getLanguageLabel(lang) {
    return LANGUAGE_LABELS[lang];
}
// Topical tags only — the language axis (ko/en) is presented separately, not
// as a content tag.
function getTopicTags(post) {
    return post.tags.filter((t) => !LANGUAGE_TAGS.includes(t.toLowerCase()));
}
